import { trackCTAClick } from '@/lib/analytics';
import { useTranslation } from 'react-i18next';

const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  el.scrollIntoView({ behavior: prefersReduced ? 'instant' : 'smooth', block: 'start' });
};

export const FinalCTA = () => {
  const { t } = useTranslation();
  return (
    <section
      data-testid="final-cta-section"
      className="py-16 lg:py-24 px-6 sm:px-8 relative overflow-hidden"
      style={{ backgroundColor: 'var(--vc-bg-3)' }}
    >
      {/* Gradient mesh background */}
      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none"
        style={{
          background: `
            radial-gradient(600px circle at 30% 50%, rgba(214,168,74,0.06), transparent 60%),
            radial-gradient(400px circle at 70% 30%, rgba(214,168,74,0.04), transparent 50%),
            radial-gradient(500px circle at 60% 80%, rgba(255,255,255,0.02), transparent 50%)
          `,
        }}
      />
      <div className="relative max-w-[1160px] mx-auto text-center">
        <h2
          className="font-bold tracking-tight text-2xl sm:text-3xl lg:text-[34px]"
          style={{ fontFamily: 'Inter, sans-serif', color: 'var(--vc-fg)' }}
        >
          {t('finalcta.title')}
        </h2>

        <button
          data-testid="final-primary-cta-button"
          onClick={() => {
            trackCTAClick('final_primary');
            scrollToSection('waitlist');
          }}
          className="mt-8 inline-flex items-center justify-center h-12 px-8 text-sm font-medium rounded-xl transition-colors duration-200 active:scale-[0.98]"
          style={{
            backgroundColor: 'var(--vc-gold)',
            color: 'var(--vc-ink)',
            fontFamily: 'Inter, sans-serif',
          }}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'var(--vc-gold-2)'}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'var(--vc-gold)'}
        >
          {t('finalcta.cta')}
        </button>

        <p
          className="mt-6 text-xs tracking-widest uppercase"
          style={{ color: 'var(--vc-fg-subtle)', fontFamily: 'Inter, sans-serif' }}
        >
          {t('finalcta.badges')}
        </p>
      </div>
    </section>
  );
};
